import { LaneType, LaneIntegrationType } from 'common-types';

import { PublicUserType } from '../../hooks/useMyPublicUsersQuery';
import { IWizardState } from '../../hooks/useWizard';
import { ContentType } from '../content/Content';
import { ShopifyChannelType } from './ShopifyBurst';

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use ShopifyRsvpDraftInteractionData from application-types instead.
 */
export type ShopifyRsvpDraftInteractionData =
  Partial<LaneIntegrationType.ShopifyRsvpInteraction>;

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use ShopifyRsvpWizardState from application-types instead.
 */
export type ShopifyRsvpWizardState = Pick<
  IWizardState<ShopifyRsvpDraftInteractionData>,
  'data' | 'currentStepIndex'
>;

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use SHOPIFY_BURST_RSVP_VALID_DAYS from application-types instead.
 */
export const SHOPIFY_BURST_RSVP_VALID_DAYS = 14;

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ShopifyBurstRsvpEntryTimeValidEnum from application-types instead.
 */
export enum ShopifyBurstRsvpEntryTimeValidEnum {
  /** not sure yet if this is valid, we maybe loading the info */
  Unknown = 'Unknown',
  /** we have passed the entry time on this burst */
  Invalid = 'Invalid',
  /** the user is still allowed to submit */
  Valid = 'Valid',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use ShopifyBurstInteractionCacheType from application-types instead.
 */
export type ShopifyBurstInteractionCacheType = {
  contentId: string;
  contentName: string;
  contentDescription: string;
  contentData: object;
  features: object;
  interactionId: string;
  interactionStartDate: Date;
  interactionEndDate: Date;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use ShopifyRsvpContentStateType from application-types instead.
 */
export type ShopifyRsvpContentStateType = {
  shopifyBurstContentId: LaneType.UUID;
  shopifyBurstInteractionId: LaneType.UUID;
  attendees: PublicUserType[];
  l9?: PublicUserType;
  attendeesCount: number;
  name: LaneType.String;
  port?: ShopifyChannelType;
  portTimeZone?: string;
  dateRange: LaneType.DateTimeRange;
  dailySchedule?: LaneType.UserContentInteraction;
  primaryRoomBooking?: LaneType.UserContentInteraction;
  activitiesBookings?: Array<LaneType.UserContentInteraction>;
  dailyScheduleData?: ShopifyBurstInteractionCacheType;
  primaryRoomBookingData?: ShopifyBurstInteractionCacheType;
  activitiesBookingsData?: ShopifyBurstInteractionCacheType[];
  acknowledgementContent?: ContentType;
  burstNameContent?: ContentType;
  /** @deprecated this field was preserved for backward compatability with old mobile versions that work with only v1 schema */
  questionnaire: LaneType.ShopifyBurstQuestionnaireTypeV2;
  questionnaireInteraction?: any;
  questionnaireContent?: ContentType;
  /** @deprecated this field was preserved for backward compatability with old mobile versions that work with only v1 schema */
  specialRequest: string;
  specialRequestContent?: ContentType;
  specialRequestInteraction?: any;
  isDiyBurst?: boolean;
  diyQuestions?: any;
  diyQuestionsContent?: ContentType;
  schemaVersion?: number;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use RSVPContent from application-types instead.
 */
export type RSVPContent = ContentType & {
  state: {
    _ShopifyBurst: ShopifyRsvpContentStateType;
  };
  channelId: LaneType.UUID;
  placements?: { user?: { _id: LaneType.UUID } }[];
};

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ShopifyRsvpTabsEnum from application-types instead.
 */
export enum ShopifyRsvpTabsEnum {
  Invited = 'invited',
  Declined = 'declined',
  Accepted = 'accepted',
}

// FIXME: Enum nesting is not valid for isolated modules
// Can we not just use the originl enum?
/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ShopifyRsvpStatusEnum from application-types instead.
 */
export enum ShopifyRsvpStatusEnum {
  /** -> Shopifolk responded Yes to RSVP */
  Accepted = 'Accepted', // INTERACTION_ACCEPTED,
  /** -> Shopifolk responded No to RSVP */
  Declined = 'Declined', // INTERACTION_DECLINED,
  /** -> The burst was cancelled */
  Cancelled = 'Cancelled', // INTERACTION_CANCELLED,
  /** -> The burst was confirmed */
  Confirmed = 'Confirmed', // INTERACTION_CONFIRMED,
  /** -> Awaiting response from Shopifolk member */
  Awaiting = 'Awaiting Response', // INTERACTION_AWAITING_RESPONSE,
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use rsvpAttendTitle from application-types instead.
 */
export const rsvpAttendTitle = `Will you be attending this burst in person?`;
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use rsvpAttendNote from application-types instead.
 */
export const rsvpAttendNote = `Note: if you cannot attend in person please click ‘No’, however remote attendance is still required for bursts. You will be included in all calendar invites as well.`;
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use rsvpChangeNote from application-types instead.
 */
export const rsvpChangeNote =
  'If you need to change your RSVP, you can always come back and update your submission.';
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use specialRequestTitle from application-types instead.
 */
export const specialRequestTitle = `Add special requests`;
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use specialRequestNote from application-types instead.
 */
export const specialRequestNote = `Note: Travel will be booked separately once your burst has been confirmed by email.`;
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use specialRequestPlaceholder from application-types instead.
 */
export const specialRequestPlaceholder = `Dietary restrictions? Accessibility requests?`;
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use covidRegulationsTitle from application-types instead.
 */
export const covidRegulationsTitle = `I understand Shopify's COVID-19 regulations and have uploaded my proof of vaccination to Workday.`;
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use shopifyVaultRsvpLink from application-types instead.
 */
export const shopifyVaultRsvpLink =
  'https://vault.shopify.io/pages/12466-Uploading-Your-Vaccination-Records';
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use covidRegulationsErrorMessage from application-types instead.
 */
export const covidRegulationsErrorMessage = `Due to Shopify’s Covid-19 vaccination policies, you are not able to attend this burst in person. Please change your in-person attendance to ‘No’ to complete your RSVP.`;
